module.exports = __webpack_public_path__ + "img/visa.5e3269de.svg";